import Slider from "react-slick";
import styled from "styled-components";
import React, { useState, useEffect, useRef } from "react";
// import { ImageSelector } from "../App";

const Title = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: #bf4f74;
`;
const basePath = window.location.pathname.includes("/minecraft.dev")
  ? "/minecraft.dev"
  : "";

export function Bordered(props) {
  return (
    <div className="bordered-cnt">
      <div className="bordered">{props.children}</div>
    </div>
  );
}

export function Carousel(props) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);
  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);
  var settings = {
    dots: false,
    fade: true,
    waitForAnimate: false,
    infinite: false,
    arrows: false,
    speed: 500,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
    ],
    ...props,
  };
  return (
    <>
      <div className="carousel-nav">
        <Slider
          slidesToShow={4}
          swipeToSlide={true}
          dots={false}
          infinite={false}
          speed={500}
          arrows={false}
          focusOnSelect={true}
          asNavFor={nav1}
          ref={(slider) => (sliderRef2 = slider)}
        >
          <Bordered>
            <img src={`${basePath}/img/Meal_Box.png`} />
          </Bordered>
          <Bordered>
            <img src={`${basePath}/img/Grimmace-Toy.png`} />
          </Bordered>
          <Bordered>
            <img
              src={`${basePath}/img/29984_Master1a_NetherSauce_Left_Twilight_r2_72.png`}
            />
          </Bordered>
          <Bordered>
            <img src={`${basePath}/img/MC-flurry.png`} />
          </Bordered>
        </Slider>
      </div>
      <div className="carousel-nav2">
        <Slider
          {...settings}
          asNavFor={nav2}
          ref={(slider) => (sliderRef1 = slider)}
        >
          {props.children}
        </Slider>
      </div>
    </>
  );
}

export function ProductEl(props) {
  if (!props.variant || props.variant === "v1") {
    return (
      <div className="product-el">
        <img src={props.product.img} />
        <div className="product-content">
          <h3>{props.product.name}</h3>
          <p>{props.product.desc}</p>
          <Button link={props.product.link} variant="v2">
            {props.product.cta}
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div className="product-el product-v2">
      <div className="bordered-cnt">
        <div className="bordered">
          <div className="img">
            <img src={props.product.img} />
          </div>
        </div>
      </div>
      <h3>{props.product.name}</h3>
      <p>{props.product.desc}</p>
      <Button link={props.product.link} variant="v3">
        {props.product.cta}
      </Button>
    </div>
  );
}

// const [selected, setSelected] = useState(null);
// const images = [
//   { id: 1, src: "/img/MC-flurry.png", text: "Hamburglar" },
//   { id: 2, src: "/img/MC-flurry.png", text: "Grimace" },
//   { id: 3, src: "/img/MC-flurry.png", text: "Birdie the Early Bird" },
//   { id: 4, src: "/img/MC-flurry.png", text: "McDonald's Drink" },
//   { id: 5, src: "/img/MC-flurry.png", text: "McDonald's Fries" },
//   { id: 6, src: "/img/MC-flurry.png", text: "Big Mac" },
// ];

// export function ImageSelector({ images, selected, setSelected }) {
//   return (
//     <div className="container">
//       <div className="grid-container">
//         {images.map((img) => (
//           <div
//             key={img.id}
//             className={`grid-item
//                 ${selected === img.id ? "selected" : ""}
//                 `}
//             onClick={() => setSelected(img.id)}
//           >
//             <img className="images_carousel" src={img.src} alt={img.text} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }
export function ImageSelector({ images, selected, setSelected }) {
  return (
    <div className="container_ImageSelector">
      <div className="grid-container">
        {images.map((img) => (
          <div
            key={img.id}
            className={`grid-item`}
            onClick={() => setSelected(img.id)}
          >
            <img className="images_carousel" src={img.src} alt={img.text} />
          </div>
        ))}
      </div>
    </div>
  );
}
export function ProductElt(props) {
  const [selected, setSelected] = useState(1);

  const images = [
    {
      id: 1,
      src: `${basePath}/img/Burger Toy.png`,
      text: {
        name: {
          fr: "Big Mac Crystal",
          de: "Big Mac Crystal",
          it: "Big Mac Crystal",
        },
        desc: {
          fr: "un précieux cube contenant les ingrédients de notre burger mythique.  ",
          de: "Ein wertvoller Würfel mit den Zutaten des legendären Burgers.",
          it: "un prezioso dado con gli ingredienti del leggendario burger.  ",
        },
      },
    },
    {
      id: 2,
      src: `${basePath}/img/img-2.png`,
      text: {
        name: {
          fr: "Birdie Wings",
          de: "Birdie Wings",
          it: "Birdie Wings",
        },
        desc: {
          fr: "ces élytres sont des ailes qui appartiennent à l’oiseau magique qui vole haut dans le ciel.  ",
          de: "Diese Elytra-Flügel gehören dem magischen Vogel, der hoch am Himmel kreist.",
          it: "queste ali di Elytra appartengono al magico uccello che vola in alto nel cielo. ",
        },
      },
    },

    {
      id: 3,
      src: `${basePath}/img/Helmet Toy 1.png`,
      text: {
        name: {
          fr: "Fry Helmet",
          de: "Fry Helmet",
          it: "Fry Helmet",
        },
        desc: {
          fr: "ce véritable casque de héros est fabriqué à partir d'une boîte de frites et te protège contre les voleurs de frites.",
          de: "Ein heldenhafter Helm aus einer Pommes-Box, der vor Pommes-Dieben schützt. ",
          it: "un elmetto degno di un eroe ricavato da una scatola di patatine che protegge dai ladri di patatine fritte.  ",
        },
      },
    },

    {
      id: 4,
      src: `${basePath}/img/Grimace_Menu 1.png`,
      text: {
        name: {
          fr: "Grimace Egg",
          de: "Grimace Egg",
          it: "Grimace Egg",
        },
        desc: {
          fr: "cette créature fantastique se tapit dans les profondeurs d’un milkshake violet.  ",
          de: "Aus den Tiefen eines lila Milchshakes taucht dieses magische Wesen auf. ",
          it: "dalle profondità di un milkshake viola emerge questa creatura magica.  ",
        },
      },
    },

    {
      id: 5,
      src: `${basePath}/img/Potion Toy.png`,
      text: {
        name: {
          fr: "Soda Potion",
          de: "Soda Potion",
          it: "Soda Potion",
        },
        desc: {
          fr: "une boisson pleine de secrets, composée d’arômes pétillants et variés.  ",
          de: "Ein geheimnisvoller Trank aus vielfältigen, prickelnden Aromen.",
          it: "una bevanda misteriosa dai molteplici aromi frizzanti. ",
        },
      },
    },

    {
      id: 6,
      src: `${basePath}/img/Toys1.png`,
      text: {
        name: {
          fr: "Zombie Hamburger ",
          de: "Zombie Hamburger",
          it: "Zombie burger ",
        },
        desc: {
          fr: "un zombie qui apparaît la nuit et cherche des burgers dans tous les biomes.",
          de: "Ein hungriger Mob, der nachts spawnt und in allen Biomen nach Burgern sucht.  ",
          it: "una folla affamata che si riproduce di notte in cerca di burger in tutti i biomi. ",
        },
      },
    },
  ];
  const des = {
    fr: "Chaque figurine à collectionner contient une carte avec un code à usage unique qui permet de débloquer un skin exclusif sur la marketplace Minecraft. ",
    de: "Jedes Sammlerfigurin enthält eine passende Karte mit einem einmalig einlösbaren Code, der exklusive Skins im Minecraft Marketplace freischaltet.  ",
    it: "Ogni personaggio da collezione contiene una carta corrispondente con un codice utilizzabile una sola volta che sblocca skin esclusivi su Minecraft Marketplace.",
  };

  const lang = props.lang;

  if (!props.variant || props.variant === "v1") {
    return (
      <div className="product-el product_details_carousel">
        <div className="bordered-cnt">
          <div className="bordered ">
            {props.product.multiple.length > 0 ? (
              <div className="bordered_carousel">
                <ImageSelector
                  images={images}
                  selected={selected}
                  setSelected={setSelected}
                />
              </div>
            ) : (
              <>
                <img
                  src={props.product.img}
                  className="img"
                  style={{ height: "185px" }}
                />
                <Button variant="v4" link={props.product.link}>
                  {props.product.cta}
                </Button>
              </>
            )}
          </div>

          <div className="product-content carousel_content">
            <h3>{props.product.name}</h3>
            <p>
              {props.product.desc}
              {props.product.multiple.length > 0 && (
                <>
                  {images.map((img) => (
                    <li>
                      <strong>{img.text.name[lang]}: </strong>
                      {img.text.desc[lang]}
                      <br />
                      {/* <strong>
                      {selected &&
                        images.find((img) => img.id === selected)?.text.name[
                          lang
                        ]}{" "}
                      :{" "}
                    </strong>
                    {selected &&
                      images.find((img) => img.id === selected)?.text.desc[
                        lang
                      ]} */}
                    </li>
                  ))}
                  <br />
                  <p>{des[lang]}</p>
                </>
              )}
            </p>
            {props.product.multiple.length == 0 && props.product.link ? null : (
              <Button
                variant="v3"
                link={props.product.link}
                style={{ filter: "brightness(0.8)" }}
              >
                {props.product.cta}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="product-el product-v2">
      <div className="bordered-cnt">
        <div className="bordered">
          <div className="img">
            <img src={props.product.img} />
          </div>
        </div>
      </div>
      <h3>{props.product.name}</h3>
      <p>{props.product.desc}</p>

      <Button link={props.product.link} variant="v3">
        {props.product.cta}
      </Button>
    </div>
  );
}
export function DescriptionElt(props) {
  return (
    <div className="product-el product-v2">
      {/* <div className="bordered-cnt">
        <div className="bordered">
          <div className="img">
            <img src={props.product.img} /> 
          </div>
        </div>
      </div> */}
      {/* {props.FAQ.name && <h3>{props.FAQ.name}</h3>} */}
      <p>{props.FAQ.desc}</p>

      {props.FAQ.cta && (
        <Button link={props.FAQ.link} variant="v3">
          {props.FAQ.cta}
        </Button>
      )}
    </div>
  );
}
export function ProductElementDetail(props) {
  return (
    <div className="product-el detail_el">
      <div className="bordered-cnt">
        <div className="bordered bordred_image">
          <img src={props.product.img} />
        </div>
      </div>
      <div className="product-content carousel_content">
        <h3>{props.product.name}</h3>
        <p>{props.product.desc}</p>
        <Button variant="v3" link={props.product.link}>
          {props.product.cta}
        </Button>
      </div>
    </div>
  );
}
export function ProductEltDetail(props) {
  return (
    <div className="product-el detail_el">
      <div className="bordered-cnt">
        <div className="bordered bordred_image">
          <img src={props.product.img} />
        </div>

        <div className="product-content carousel_content">
          <h3>{props.product.name}</h3>
          <p>{props.product.desc}</p>
          <Button variant="v3" link={props.product.link}>
            {props.product.cta}
          </Button>
        </div>
      </div>
    </div>
  );
}

export function VideoLaunch(props) {
  return (
    <div className="video-launch" {...props}>
      <div className="playbg"></div>
      <div className="play">
        <img src={`${basePath}/img/play.svg`} />
      </div>
      {props.children}
    </div>
  );
}

const Vs = {};
Vs.v1 = styled.a`
  border: 0 solid;
  border-radius: 44px;
  min-width: 260px;
  height: 65px;
  background: #d00024;
  font-family: var(--font-family);
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  text-align: center;
  color: #fff;
  display: inline-flex;
  width: auto;
  border-image: url("${basePath}/img/CTA2.png") 28 fill/21px/0px repeat;
`;
Vs.v2 = styled.a`
  font-family: var(--font-family);
  font-weight: bold;
  font-size: 25px;
  line-height: 112%;
  text-align: center;
  color: #292929;
  min-height: 75px;
  //border-image: url("${basePath}/img/CTA.png") 18 fill/20px/0px repeat;
  background-image: url("${basePath}/img/CTA.png");
  background-repeat: no-repeat;
  width: 100%;
  display: flex;

  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  margin: 50px 0px;
`;
Vs.v3 = styled.a`
  border: 0 solid;
  border-radius: 10px;
  width: 300px;
  height: 65px;
  font-family: var(--font-family);
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  text-align: center;
  color: #000;
  padding: 0 40px;
  background-size: cover;
  background-image: url("${basePath}/img/CTA.png");
`;
Vs.v4 = styled.a`
  border: 0 solid;
  border-radius: 10px;
  min-width: 300px;
  height: 65px;
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
  text-align: center;
  color: #000;
  padding: 0 40px;
  border-image: url("${basePath}/img/CTA2.png") 28 fill/21px/0px repeat;
  @media (max-width: 768px) {
    min-width: 0;
  }
`;
export function Button(props) {
  console.log(props);

  let CV = Vs[props.variant || "v1"];
  return (
    <CV className="m-btn" href={props.link} {...props}>
      {props.children}
    </CV>
  );
}

export const Vsv1 = styled.a`
  color: black;
  font-size: 31px;
  font-family: Speedee;
  font-weight: 700;
  line-height: 33.92px;
  word-wrap: break-word;
  border-image: url("${basePath}/img/Headline_Container.png") 30 fill / 20px /
    0px repeat;
  padding: 10px 20px;
  border-image-width: 12px;
`;
